/**
 * Whether she has already arrived today.
 *
 * The greeting is written once a day and pinned; the *arrival* — her per-word
 * reveal, and the one sound she makes on an ordinary morning — should happen
 * once a day too. On every later visit to the diary the same sentence is
 * simply there, the way a note left on a table is there.
 *
 * Kept in localStorage rather than Dexie, which is the opposite of what every
 * other piece of her memory does, and for a specific reason: this has to be
 * answered synchronously in the first render or the reveal starts a frame late
 * and reads as a glitch. iOS standalone WebKit does evict localStorage, which
 * is why rotation memory was moved out of it — but the worst case here is that
 * she arrives twice in one day, which nobody will ever file a bug about.
 */

const KEY = 'gramas.presence.revealedOn'

function storageKey(userId: string): string {
  return `${KEY}.${userId}`
}

/** True the first time this is asked on a given date, false after. */
export function claimDailyReveal(userId: string, date: string): boolean {
  try {
    if (localStorage.getItem(storageKey(userId)) === date) return false
    localStorage.setItem(storageKey(userId), date)
    return true
  } catch {
    // Private-mode Safari throws on access rather than returning null. An
    // arrival every time is a better failure than never arriving at all.
    return true
  }
}
